import { makeStyles } from '@material-ui/core'

const styles = makeStyles(() => ({
  // O TableCell envolve o conteúdo num Box com nowrap + ellipsis (e maxWidth de
  // 200px quando noOverFlow não é passado), o que trunca rótulo e descrição das
  // permissões. Aqui o texto precisa aparecer inteiro, quebrando linha.
  labelCell: {
    '& > div': {
      whiteSpace: 'normal',
      overflow: 'visible',
      textOverflow: 'clip',
      maxWidth: 'none',
    },
  },
}))

export default styles
